export default {"src":"/_next/static/media/wordmark.959de9c3.svg","height":180,"width":792,"blurWidth":0,"blurHeight":0};